export default "__VITE_ASSET__CtddWpz1__"